"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssignmentType = void 0;
exports.getAssignmentTypes = getAssignmentTypes;
exports.getAssignmentTypeFrom = getAssignmentTypeFrom;
var AssignmentType;
(function (AssignmentType) {
    AssignmentType["TopicQuiz"] = "TQ";
    AssignmentType["MidModuleAssessment"] = "MMA";
    AssignmentType["EndOfModuleAssessment"] = "EOMA";
    AssignmentType["Vocabulary"] = "VOC";
    AssignmentType["WWEOM"] = "WWEOM";
    AssignmentType["QuestionSet"] = "Question Set";
    AssignmentType["ModuleAssessment"] = "MA";
    AssignmentType["FQT"] = "FQT";
    AssignmentType["Benchmark"] = "Benchmark";
    AssignmentType["NR"] = "NR";
    AssignmentType["Equip"] = "Equip";
    AssignmentType["CC"] = "CC";
    AssignmentType["EoMT"] = "EoMT";
    AssignmentType["LCT"] = "LCT";
    AssignmentType["MT"] = "MT";
    AssignmentType["RCT"] = "RCT";
    AssignmentType["EC"] = "EC";
    AssignmentType["SC"] = "SC";
    AssignmentType["CP"] = "CP";
    AssignmentType["SQ"] = "SQ";
    AssignmentType["EoSA"] = "EoSA";
    AssignmentType["TT"] = "TT";
})(AssignmentType || (exports.AssignmentType = AssignmentType = {}));
function getAssignmentTypes() {
    return Object.values(AssignmentType);
}
function getAssignmentTypeFrom(value) {
    return getAssignmentTypes().find(function (type) { return type === value; });
}
